import React from 'react';
import { Box, Typography, Button } from '@mui/material';

function SessionExpired() {
    const handleLogin = () => {
        localStorage.removeItem('logged-out');
        window.location.replace('/');
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            textAlign="center"
            p={3}
        >
            <Typography variant="h4" gutterBottom>
                Session Expired
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                Your session has expired due to inactivity or logout. Please log in again to continue.
            </Typography>
            <Button variant="contained" color="primary" onClick={handleLogin}>
                Log In
            </Button>
        </Box>
    );
}

export default SessionExpired;
